import gql from "graphql-tag";

export const viewBlogMutation = gql`
    mutation ViewBlogMutation($blogId: String!, $userId: String) {
        viewBlog(blogId: $blogId, userId: $userId) {
            post {
                numberOfViews
            }
        }
    }
`;
